import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import DetailPageWrapper from '../../components/DetailPageWrapper';
import Breadcrumbs from '../../components/Breadcrumbs';
import DetailHeader from './DetailHeader';
import DetailMenu from './DetailMenu';
import Overview from './Overview';
import Description from './Description';
import Homes from './Homes';
import FloorPlans from './FloorPlans';
import PhotoGallery from './PhotoGallery';
import SiteMap from './SiteMap';
import Schools from './Schools';
import Map from './Map';
import Disclaimer from './Disclaimer';

function CommunityDetail({ community, homes, plans, agents }) {
  return (
    <PageWrapper>
      <PageHelmet community={community} />
      <DetailPageWrapper>
        <Breadcrumbs community={community} />
        <DetailHeader community={community} />
        <DetailMenu community={community} />
        <Overview community={community} agents={agents} />
        <FloorPlans community={community} plans={plans} />
        <Homes community={community} homes={homes} />
        <PhotoGallery community={community} />
        <Description community={community} />
        <SiteMap community={community} homes={homes} />
        <Schools community={community} />
        <Map community={community} />
        <Disclaimer community={community} />
      </DetailPageWrapper>
    </PageWrapper>
  );
}

CommunityDetail.propTypes = {
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
  agents: PropTypes.arrayOf(PropTypes.object),
};

CommunityDetail.defaultProps = {
  homes: [],
  plans: [],
  agents: [],
};

export default withData(
  {
    community: true,
    homes: true,
    plans: true,
    agents: true,
  },
  {
    required: {
      community: true,
    },
    ifMissing404: true,
  },
)(CommunityDetail);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/index.js